import {AddOn} from "@softline/application";
import { Signal } from '@angular/core';
import { BusinessCase } from '../types/business-case';

export interface BusinessCaseAddOnParams {
  selected: Signal<BusinessCase[]>
}

export abstract class BusinessCaseAddon extends AddOn<BusinessCaseAddOnParams> {

}
